import React from 'react'
import FormControl, {FormControlProps} from '@mui/material/FormControl'
import styled from 'styled-components'
import fieldsetStyles, {fieldsetWrapperStyles} from './fieldset.styles'

const apAtomName = {ap_atom_name: 'fieldsetAtom'}

const FieldsetWrapper = styled(props => <div {...props} />)`
  ${fieldsetWrapperStyles}
`

const FieldsetAtom = styled((props: FormControlProps) => (
  <FieldsetWrapper className="fieldset-wrapper" id={props.id}>
    <FormControl fullWidth {...apAtomName} component="fieldset">
      {props.children}
    </FormControl>
  </FieldsetWrapper>
))`
  ${fieldsetStyles};
`

export default FieldsetAtom
